/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedOpportunitiesRouteRouteImport } from './routes/_authenticated/opportunities/route'
import { Route as AuthenticatedInquiriesRouteRouteImport } from './routes/_authenticated/inquiries/route'
import { Route as AuthenticatedOpportunitiesIndexRouteImport } from './routes/_authenticated/opportunities/index'
import { Route as AuthenticatedInquiriesIndexRouteImport } from './routes/_authenticated/inquiries/index'
import { Route as AuthenticatedOpportunitiesPublicRouteRouteImport } from './routes/_authenticated/opportunities/public/route'
import { Route as AuthenticatedOpportunitiesMypageRouteRouteImport } from './routes/_authenticated/opportunities/mypage/route'
import { Route as AuthenticatedOpportunitiesOpportunityIdRouteRouteImport } from './routes/_authenticated/opportunities/$opportunityId/route'
import { Route as AuthenticatedOpportunitiesTasksIndexRouteImport } from './routes/_authenticated/opportunities/tasks/index'
import { Route as AuthenticatedOpportunitiesPublicIndexRouteImport } from './routes/_authenticated/opportunities/public/index'
import { Route as AuthenticatedOpportunitiesMypageIndexRouteImport } from './routes/_authenticated/opportunities/mypage/index'
import { Route as AuthenticatedOpportunitiesListIndexRouteImport } from './routes/_authenticated/opportunities/list/index'
import { Route as AuthenticatedOpportunitiesOpportunityIdIndexRouteImport } from './routes/_authenticated/opportunities/$opportunityId/index'
import { Route as AuthenticatedOpportunitiesOpportunityIdPropertiesRouteImport } from './routes/_authenticated/opportunities/$opportunityId/properties'
import { Route as AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRouteImport } from './routes/_authenticated/opportunities/mypage/incentive-confirm/index'
import { Route as AuthenticatedOpportunitiesPublicIdPropertiesIndexRouteImport } from './routes/_authenticated/opportunities/public/$id/properties/index'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOpportunitiesRouteRoute =
  AuthenticatedOpportunitiesRouteRouteImport.update({
    id: '/opportunities',
    path: '/opportunities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInquiriesRouteRoute =
  AuthenticatedInquiriesRouteRouteImport.update({
    id: '/inquiries',
    path: '/inquiries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOpportunitiesIndexRoute =
  AuthenticatedOpportunitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedInquiriesIndexRoute =
  AuthenticatedInquiriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInquiriesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesPublicRouteRoute =
  AuthenticatedOpportunitiesPublicRouteRouteImport.update({
    id: '/public',
    path: '/public',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesMypageRouteRoute =
  AuthenticatedOpportunitiesMypageRouteRouteImport.update({
    id: '/mypage',
    path: '/mypage',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesOpportunityIdRouteRoute =
  AuthenticatedOpportunitiesOpportunityIdRouteRouteImport.update({
    id: '/$opportunityId',
    path: '/$opportunityId',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesTasksIndexRoute =
  AuthenticatedOpportunitiesTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesPublicIndexRoute =
  AuthenticatedOpportunitiesPublicIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunitiesPublicRouteRoute,
  } as any)
const AuthenticatedOpportunitiesMypageIndexRoute =
  AuthenticatedOpportunitiesMypageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunitiesMypageRouteRoute,
  } as any)
const AuthenticatedOpportunitiesListIndexRoute =
  AuthenticatedOpportunitiesListIndexRouteImport.update({
    id: '/list/',
    path: '/list/',
    getParentRoute: () => AuthenticatedOpportunitiesRouteRoute,
  } as any)
const AuthenticatedOpportunitiesOpportunityIdIndexRoute =
  AuthenticatedOpportunitiesOpportunityIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunitiesOpportunityIdRouteRoute,
  } as any)
const AuthenticatedOpportunitiesOpportunityIdPropertiesRoute =
  AuthenticatedOpportunitiesOpportunityIdPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => AuthenticatedOpportunitiesOpportunityIdRouteRoute,
  } as any)
const AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute =
  AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRouteImport.update({
    id: '/incentive-confirm/',
    path: '/incentive-confirm/',
    getParentRoute: () => AuthenticatedOpportunitiesMypageRouteRoute,
  } as any)
const AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute =
  AuthenticatedOpportunitiesPublicIdPropertiesIndexRouteImport.update({
    id: '/$id/properties/',
    path: '/$id/properties/',
    getParentRoute: () => AuthenticatedOpportunitiesPublicRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/inquiries': typeof AuthenticatedInquiriesRouteRouteWithChildren
  '/opportunities': typeof AuthenticatedOpportunitiesRouteRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginIndexRoute
  '/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdRouteRouteWithChildren
  '/opportunities/mypage': typeof AuthenticatedOpportunitiesMypageRouteRouteWithChildren
  '/opportunities/public': typeof AuthenticatedOpportunitiesPublicRouteRouteWithChildren
  '/inquiries/': typeof AuthenticatedInquiriesIndexRoute
  '/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/opportunities/$opportunityId/properties': typeof AuthenticatedOpportunitiesOpportunityIdPropertiesRoute
  '/opportunities/$opportunityId/': typeof AuthenticatedOpportunitiesOpportunityIdIndexRoute
  '/opportunities/list': typeof AuthenticatedOpportunitiesListIndexRoute
  '/opportunities/mypage/': typeof AuthenticatedOpportunitiesMypageIndexRoute
  '/opportunities/public/': typeof AuthenticatedOpportunitiesPublicIndexRoute
  '/opportunities/tasks': typeof AuthenticatedOpportunitiesTasksIndexRoute
  '/opportunities/mypage/incentive-confirm': typeof AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute
  '/opportunities/public/$id/properties': typeof AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginIndexRoute
  '/inquiries': typeof AuthenticatedInquiriesIndexRoute
  '/opportunities': typeof AuthenticatedOpportunitiesIndexRoute
  '/opportunities/$opportunityId/properties': typeof AuthenticatedOpportunitiesOpportunityIdPropertiesRoute
  '/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdIndexRoute
  '/opportunities/list': typeof AuthenticatedOpportunitiesListIndexRoute
  '/opportunities/mypage': typeof AuthenticatedOpportunitiesMypageIndexRoute
  '/opportunities/public': typeof AuthenticatedOpportunitiesPublicIndexRoute
  '/opportunities/tasks': typeof AuthenticatedOpportunitiesTasksIndexRoute
  '/opportunities/mypage/incentive-confirm': typeof AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute
  '/opportunities/public/$id/properties': typeof AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/inquiries': typeof AuthenticatedInquiriesRouteRouteWithChildren
  '/_authenticated/opportunities': typeof AuthenticatedOpportunitiesRouteRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdRouteRouteWithChildren
  '/_authenticated/opportunities/mypage': typeof AuthenticatedOpportunitiesMypageRouteRouteWithChildren
  '/_authenticated/opportunities/public': typeof AuthenticatedOpportunitiesPublicRouteRouteWithChildren
  '/_authenticated/inquiries/': typeof AuthenticatedInquiriesIndexRoute
  '/_authenticated/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/_authenticated/opportunities/$opportunityId/properties': typeof AuthenticatedOpportunitiesOpportunityIdPropertiesRoute
  '/_authenticated/opportunities/$opportunityId/': typeof AuthenticatedOpportunitiesOpportunityIdIndexRoute
  '/_authenticated/opportunities/list/': typeof AuthenticatedOpportunitiesListIndexRoute
  '/_authenticated/opportunities/mypage/': typeof AuthenticatedOpportunitiesMypageIndexRoute
  '/_authenticated/opportunities/public/': typeof AuthenticatedOpportunitiesPublicIndexRoute
  '/_authenticated/opportunities/tasks/': typeof AuthenticatedOpportunitiesTasksIndexRoute
  '/_authenticated/opportunities/mypage/incentive-confirm/': typeof AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute
  '/_authenticated/opportunities/public/$id/properties/': typeof AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/inquiries'
    | '/opportunities'
    | '/'
    | '/login'
    | '/opportunities/$opportunityId'
    | '/opportunities/mypage'
    | '/opportunities/public'
    | '/inquiries/'
    | '/opportunities/'
    | '/opportunities/$opportunityId/properties'
    | '/opportunities/$opportunityId/'
    | '/opportunities/list'
    | '/opportunities/mypage/'
    | '/opportunities/public/'
    | '/opportunities/tasks'
    | '/opportunities/mypage/incentive-confirm'
    | '/opportunities/public/$id/properties'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/inquiries'
    | '/opportunities'
    | '/opportunities/$opportunityId/properties'
    | '/opportunities/$opportunityId'
    | '/opportunities/list'
    | '/opportunities/mypage'
    | '/opportunities/public'
    | '/opportunities/tasks'
    | '/opportunities/mypage/incentive-confirm'
    | '/opportunities/public/$id/properties'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/inquiries'
    | '/_authenticated/opportunities'
    | '/_authenticated/'
    | '/login/'
    | '/_authenticated/opportunities/$opportunityId'
    | '/_authenticated/opportunities/mypage'
    | '/_authenticated/opportunities/public'
    | '/_authenticated/inquiries/'
    | '/_authenticated/opportunities/'
    | '/_authenticated/opportunities/$opportunityId/properties'
    | '/_authenticated/opportunities/$opportunityId/'
    | '/_authenticated/opportunities/list/'
    | '/_authenticated/opportunities/mypage/'
    | '/_authenticated/opportunities/public/'
    | '/_authenticated/opportunities/tasks/'
    | '/_authenticated/opportunities/mypage/incentive-confirm/'
    | '/_authenticated/opportunities/public/$id/properties/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities': {
      id: '/_authenticated/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof AuthenticatedOpportunitiesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inquiries': {
      id: '/_authenticated/inquiries'
      path: '/inquiries'
      fullPath: '/inquiries'
      preLoaderRoute: typeof AuthenticatedInquiriesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities/': {
      id: '/_authenticated/opportunities/'
      path: '/'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/inquiries/': {
      id: '/_authenticated/inquiries/'
      path: '/'
      fullPath: '/inquiries/'
      preLoaderRoute: typeof AuthenticatedInquiriesIndexRouteImport
      parentRoute: typeof AuthenticatedInquiriesRouteRoute
    }
    '/_authenticated/opportunities/public': {
      id: '/_authenticated/opportunities/public'
      path: '/public'
      fullPath: '/opportunities/public'
      preLoaderRoute: typeof AuthenticatedOpportunitiesPublicRouteRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/opportunities/mypage': {
      id: '/_authenticated/opportunities/mypage'
      path: '/mypage'
      fullPath: '/opportunities/mypage'
      preLoaderRoute: typeof AuthenticatedOpportunitiesMypageRouteRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/opportunities/$opportunityId': {
      id: '/_authenticated/opportunities/$opportunityId'
      path: '/$opportunityId'
      fullPath: '/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOpportunitiesOpportunityIdRouteRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/opportunities/tasks/': {
      id: '/_authenticated/opportunities/tasks/'
      path: '/tasks'
      fullPath: '/opportunities/tasks'
      preLoaderRoute: typeof AuthenticatedOpportunitiesTasksIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/opportunities/public/': {
      id: '/_authenticated/opportunities/public/'
      path: '/'
      fullPath: '/opportunities/public/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesPublicIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesPublicRouteRoute
    }
    '/_authenticated/opportunities/mypage/': {
      id: '/_authenticated/opportunities/mypage/'
      path: '/'
      fullPath: '/opportunities/mypage/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesMypageIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesMypageRouteRoute
    }
    '/_authenticated/opportunities/list/': {
      id: '/_authenticated/opportunities/list/'
      path: '/list'
      fullPath: '/opportunities/list'
      preLoaderRoute: typeof AuthenticatedOpportunitiesListIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRouteRoute
    }
    '/_authenticated/opportunities/$opportunityId/': {
      id: '/_authenticated/opportunities/$opportunityId/'
      path: '/'
      fullPath: '/opportunities/$opportunityId/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesOpportunityIdIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesOpportunityIdRouteRoute
    }
    '/_authenticated/opportunities/$opportunityId/properties': {
      id: '/_authenticated/opportunities/$opportunityId/properties'
      path: '/properties'
      fullPath: '/opportunities/$opportunityId/properties'
      preLoaderRoute: typeof AuthenticatedOpportunitiesOpportunityIdPropertiesRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesOpportunityIdRouteRoute
    }
    '/_authenticated/opportunities/mypage/incentive-confirm/': {
      id: '/_authenticated/opportunities/mypage/incentive-confirm/'
      path: '/incentive-confirm'
      fullPath: '/opportunities/mypage/incentive-confirm'
      preLoaderRoute: typeof AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesMypageRouteRoute
    }
    '/_authenticated/opportunities/public/$id/properties/': {
      id: '/_authenticated/opportunities/public/$id/properties/'
      path: '/$id/properties'
      fullPath: '/opportunities/public/$id/properties'
      preLoaderRoute: typeof AuthenticatedOpportunitiesPublicIdPropertiesIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesPublicRouteRoute
    }
  }
}

interface AuthenticatedInquiriesRouteRouteChildren {
  AuthenticatedInquiriesIndexRoute: typeof AuthenticatedInquiriesIndexRoute
}

const AuthenticatedInquiriesRouteRouteChildren: AuthenticatedInquiriesRouteRouteChildren =
  {
    AuthenticatedInquiriesIndexRoute: AuthenticatedInquiriesIndexRoute,
  }

const AuthenticatedInquiriesRouteRouteWithChildren =
  AuthenticatedInquiriesRouteRoute._addFileChildren(
    AuthenticatedInquiriesRouteRouteChildren,
  )

interface AuthenticatedOpportunitiesOpportunityIdRouteRouteChildren {
  AuthenticatedOpportunitiesOpportunityIdPropertiesRoute: typeof AuthenticatedOpportunitiesOpportunityIdPropertiesRoute
  AuthenticatedOpportunitiesOpportunityIdIndexRoute: typeof AuthenticatedOpportunitiesOpportunityIdIndexRoute
}

const AuthenticatedOpportunitiesOpportunityIdRouteRouteChildren: AuthenticatedOpportunitiesOpportunityIdRouteRouteChildren =
  {
    AuthenticatedOpportunitiesOpportunityIdPropertiesRoute:
      AuthenticatedOpportunitiesOpportunityIdPropertiesRoute,
    AuthenticatedOpportunitiesOpportunityIdIndexRoute:
      AuthenticatedOpportunitiesOpportunityIdIndexRoute,
  }

const AuthenticatedOpportunitiesOpportunityIdRouteRouteWithChildren =
  AuthenticatedOpportunitiesOpportunityIdRouteRoute._addFileChildren(
    AuthenticatedOpportunitiesOpportunityIdRouteRouteChildren,
  )

interface AuthenticatedOpportunitiesMypageRouteRouteChildren {
  AuthenticatedOpportunitiesMypageIndexRoute: typeof AuthenticatedOpportunitiesMypageIndexRoute
  AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute: typeof AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute
}

const AuthenticatedOpportunitiesMypageRouteRouteChildren: AuthenticatedOpportunitiesMypageRouteRouteChildren =
  {
    AuthenticatedOpportunitiesMypageIndexRoute:
      AuthenticatedOpportunitiesMypageIndexRoute,
    AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute:
      AuthenticatedOpportunitiesMypageIncentiveConfirmIndexRoute,
  }

const AuthenticatedOpportunitiesMypageRouteRouteWithChildren =
  AuthenticatedOpportunitiesMypageRouteRoute._addFileChildren(
    AuthenticatedOpportunitiesMypageRouteRouteChildren,
  )

interface AuthenticatedOpportunitiesPublicRouteRouteChildren {
  AuthenticatedOpportunitiesPublicIndexRoute: typeof AuthenticatedOpportunitiesPublicIndexRoute
  AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute: typeof AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute
}

const AuthenticatedOpportunitiesPublicRouteRouteChildren: AuthenticatedOpportunitiesPublicRouteRouteChildren =
  {
    AuthenticatedOpportunitiesPublicIndexRoute:
      AuthenticatedOpportunitiesPublicIndexRoute,
    AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute:
      AuthenticatedOpportunitiesPublicIdPropertiesIndexRoute,
  }

const AuthenticatedOpportunitiesPublicRouteRouteWithChildren =
  AuthenticatedOpportunitiesPublicRouteRoute._addFileChildren(
    AuthenticatedOpportunitiesPublicRouteRouteChildren,
  )

interface AuthenticatedOpportunitiesRouteRouteChildren {
  AuthenticatedOpportunitiesOpportunityIdRouteRoute: typeof AuthenticatedOpportunitiesOpportunityIdRouteRouteWithChildren
  AuthenticatedOpportunitiesMypageRouteRoute: typeof AuthenticatedOpportunitiesMypageRouteRouteWithChildren
  AuthenticatedOpportunitiesPublicRouteRoute: typeof AuthenticatedOpportunitiesPublicRouteRouteWithChildren
  AuthenticatedOpportunitiesIndexRoute: typeof AuthenticatedOpportunitiesIndexRoute
  AuthenticatedOpportunitiesListIndexRoute: typeof AuthenticatedOpportunitiesListIndexRoute
  AuthenticatedOpportunitiesTasksIndexRoute: typeof AuthenticatedOpportunitiesTasksIndexRoute
}

const AuthenticatedOpportunitiesRouteRouteChildren: AuthenticatedOpportunitiesRouteRouteChildren =
  {
    AuthenticatedOpportunitiesOpportunityIdRouteRoute:
      AuthenticatedOpportunitiesOpportunityIdRouteRouteWithChildren,
    AuthenticatedOpportunitiesMypageRouteRoute:
      AuthenticatedOpportunitiesMypageRouteRouteWithChildren,
    AuthenticatedOpportunitiesPublicRouteRoute:
      AuthenticatedOpportunitiesPublicRouteRouteWithChildren,
    AuthenticatedOpportunitiesIndexRoute: AuthenticatedOpportunitiesIndexRoute,
    AuthenticatedOpportunitiesListIndexRoute:
      AuthenticatedOpportunitiesListIndexRoute,
    AuthenticatedOpportunitiesTasksIndexRoute:
      AuthenticatedOpportunitiesTasksIndexRoute,
  }

const AuthenticatedOpportunitiesRouteRouteWithChildren =
  AuthenticatedOpportunitiesRouteRoute._addFileChildren(
    AuthenticatedOpportunitiesRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedInquiriesRouteRoute: typeof AuthenticatedInquiriesRouteRouteWithChildren
  AuthenticatedOpportunitiesRouteRoute: typeof AuthenticatedOpportunitiesRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedInquiriesRouteRoute:
    AuthenticatedInquiriesRouteRouteWithChildren,
  AuthenticatedOpportunitiesRouteRoute:
    AuthenticatedOpportunitiesRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
